import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_PAGE_TITLE = 'My Website';

const DocumentTitleContext = React.createContext(DEFAULT_PAGE_TITLE);

/**
 * Update the page title with the given prop
 * NOTE: We use a context so that we can restore the title to whichever value is specified by the nearest parent
 */
export const DocumentTitle = ({ title, children }) => {
  const parentTitle = React.useContext(DocumentTitleContext);
  React.useEffect(() => {
    document.title = title;

    return () => {
      document.title = parentTitle;
    };
  }, [title, parentTitle]);

  return <DocumentTitleContext.Provider value={title}>{children}</DocumentTitleContext.Provider>;
};

DocumentTitle.propTypes = {
  title: PropTypes.string.isRequired,
};
DocumentTitle.displayName = 'DocumentTitle';
